import { Component, OnInit, Input, ViewChild, OnChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../../environments/environment';
import { AuthService } from '../auth/auth.service';
import { SessionsService } from '../sessions/sessions.service';
import { Subject } from 'rxjs/Subject';
import { ISession } from '../../models/session';
import { ILink } from '../../models/link';
import { contains, equals } from 'ramda/es';

@Component({
  templateUrl: './preview.component.html',
  styleUrls: ['./preview.component.scss'],
  selector: 'preview'
})
export class PreviewComponent implements OnInit {
  @Input() session: ISession;
  @Input() hash: string;

  private _links: ILink[] = [];
  get links(): ILink[] {
    return this._links;
  }
  @Input()
  set links(links: ILink[]) {
    if (!equals(links, this._links)) {
      this._links = links;
      // When updating the whole list, set loaded at false
      this.loaded = links.length <= 1;
      this.currentLink = this._links[0];
    }
  }

  public linkTranslationPrefix = 'sessions.details.links';
  public config = environment;
  public loaded = false;
  public currentLink: ILink;

  constructor(private authService: AuthService, private translateService: TranslateService) {}

  ngOnInit() {}

  ngOnChanges() {
    if (this.hash) {
      this.loaded = false;
      setTimeout(() => {
        this.loaded = true;
      }, 0);
    }
  }

  changePreviewLink(link: ILink) {
    this.currentLink = link;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/preview/preview.component.ts